import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

import { Col, Row } from 'modules/bootstrap/components';

function TermsAndConditionsPage() {
  const { t } = useTranslation(['termsAndConditions']);

  return (
    <Row className="t-h-100">
      <Col
        md={{ span: 12 }}
        xl={{ span: 10, offset: 2 }}
        style={{ paddingRight: 0 }}
      >
        <div className="t-bg-beta-50 t-rounded t-shadow-lg md:t-p-12 xs:t-px-8 xs:t-py-10 t-mb-7">
          <h1 className="Typography Typography--title u-weight-600 t-text-alpha-600">
            {t('termsAndConditions:terms_and_conditions_title')}
          </h1>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(t('termsAndConditions:terms_content')),
            }}
          />
        </div>
      </Col>
    </Row>
  );
}

export default TermsAndConditionsPage;
